import React from 'react';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  const defaultItems = [
    { label: 'Home', path: '/', current: false },
    { label: 'Sarees', path: '/sarees', current: true }
  ];

  const breadcrumbItems = items.length > 0 ? items : defaultItems;

  const handleNavigation = (item) => {
    // Handle both 'path' and 'href' properties for backward compatibility
    const targetPath = item.path || item.href || '/';
    navigate(targetPath);
  };

  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap">
      <ol className="flex items-center">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className={`flex flex-col items-start pt-px pr-2 pb-1.5 ${
            item.current ? 'text-xs whitespace-nowrap text-neutral-700' : 'text-sm text-stone-300'
          }`}>
            {item.current ? (
              <span className="font-medium text-neutral-700" aria-current="page">
                {item.label}
              </span>
            ) : (
              <button
                onClick={() => handleNavigation(item)}
                className="font-medium text-stone-300 hover:text-stone-400 cursor-pointer transition-colors focus:outline-none focus:text-stone-400 bg-transparent border-none p-0"
                aria-label={`Navigate to ${item.label}`}
                type="button"
              >
                {item.label} /
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
